import { useMutation } from '@tanstack/react-query';

import { sendRappelConseiller } from '@/services/sendRappelConseiller/sendRappelConseiller';
import { log } from '@/utils/functions/logger/logger';

export const useSendRappelConseiller = () => {
  return useMutation({
    mutationFn: sendRappelConseiller,
    onError: (error) => {
      log.error(`useSendRappelConseiller failed: ${error}`);
    },
  });
};
